import * as types from '../mutation-types'
import Vue from 'vue'
import { getWithdrawalCod } from '@/store/api/user'

const state = {
  withdraw_payment_methods: [],
  loading_withdraw_methods: false
}

const mutations = {
  [types.SET_WITHDRAW_PAYMENT_METHODS](state, data) {
    Vue.set(state, 'withdraw_payment_methods', data)
  },
  [types.SIGNOUT](state) {
    Vue.set(state, 'withdraw_payment_methods', [])
  }
}

const getters = {
  withdrawPaymentMethods: (state) => state.withdraw_payment_methods
}

const actions = {
  setWithDrawPaymentMethods: ({ commit }, data) => {
    commit(
      types.SET_WITHDRAW_PAYMENT_METHODS,
      (state.withdraw_payment_methods = {
        ...state.withdraw_payment_methods,
        ...data
      })
    )
  },

  async getWithDrawPaymentMethods({ commit }) {
    state.loading_withdraw_methods = true
    try {
      const res = await getWithdrawalCod()
      if (res) {
        commit(types.SET_WITHDRAW_PAYMENT_METHODS, res.data)
        state.loading_withdraw_methods = false
        return true
      }
    } catch (e) {
      console.error(e)
      return false
    } finally {
      state.loading_withdraw_methods = false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
